/* SIDIZ lazy video.

   The T90 page carries ~14 autoplaying background videos. Letting them all
   fetch on load competes for bandwidth, so the video the visitor is actually
   looking at arrives late and stalls — which reads as poor quality even though
   the file is fine.

   This defers every video until it is near the viewport, then attaches its
   source and plays it; videos that scroll away are paused so they stop
   consuming bandwidth and battery. The poster carries the frame until then, so
   nothing looks empty.

   Markup contract: <video data-sidiz-video preload="none" poster="…">
                      <source data-src="…" type="video/mp4">
                    </video>
   A video marked data-eager loads immediately — use it for the hero only. */

(function () {
  'use strict';

  if (window.sidizLazyVideoReady) return;
  window.sidizLazyVideoReady = true;

  var ROOT_MARGIN = '400px 0px';

  function isVisible(video) {
    return video.getClientRects().length > 0 && window.getComputedStyle(video).display !== 'none';
  }

  function applyPoster(video) {
    if (video.dataset.responsivePoster === 'true') return;
    var mobile = window.matchMedia('(max-width: 833px)').matches;
    var poster = mobile ? video.dataset.posterMobile : video.dataset.posterDesktop;
    if (!poster) poster = video.dataset.posterDesktop || video.dataset.posterMobile;
    if (poster && video.getAttribute('poster') !== poster) video.setAttribute('poster', poster);
  }

  function attach(video) {
    var sources = Array.prototype.slice.call(video.querySelectorAll('source[data-src]'));
    var selected = sources.filter(function (source) {
      var media = source.getAttribute('media');
      return !media || window.matchMedia(media).matches;
    });
    var key = selected.map(function (source) { return source.dataset.src; }).join('|');
    if (!key || video.dataset.sidizSourceKey === key) return;
    video.pause();
    var frame = video.closest('.sidiz-video-frame');
    if (frame) frame.removeAttribute('data-playing');
    sources.forEach(function (source) {
      if (selected.indexOf(source) !== -1) source.src = source.dataset.src;
      else source.removeAttribute('src');
    });
    video.dataset.sidizLoaded = 'true';
    video.dataset.sidizSourceKey = key;
    video.load();
  }

  function play(video) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || (navigator.connection && navigator.connection.saveData) || document.hidden) return;
    attach(video);
    var attempt = video.play();
    // Autoplay can still be refused (low power mode, data saver); the poster
    // stays visible, so there is nothing to recover from.
    if (attempt && typeof attempt.catch === 'function') attempt.catch(function () {});
  }

  function init(video) {
    if (video.dataset.sidizVideoReady === 'true') return;
    if (!isVisible(video)) return;
    video.dataset.sidizVideoReady = 'true';
    applyPoster(video);
    video.addEventListener('playing', function () {
      var frame = video.closest('.sidiz-video-frame');
      if (frame) frame.setAttribute('data-playing', '');
    });
    video.addEventListener('error', function () {
      var frame = video.closest('.sidiz-video-frame');
      if (frame) frame.removeAttribute('data-playing');
    });

    if (video.dataset.eager === 'true') {
      play(video);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      play(video);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            play(entry.target);
          } else if (entry.target.dataset.sidizLoaded === 'true') {
            entry.target.pause();
          }
        });
      },
      { rootMargin: ROOT_MARGIN, threshold: 0.01 }
    );

    observer.observe(video);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('video[data-sidiz-video]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      document.querySelectorAll('video[data-sidiz-video]').forEach(function (video) {
        applyPoster(video);
        var rect = video.getBoundingClientRect();
        if (isVisible(video) && rect.bottom > -400 && rect.top < window.innerHeight + 400) play(video);
      });
      boot();
    }, 120);
  });

  // Stop everything while the tab is hidden.
  document.addEventListener('visibilitychange', function () {
    document.querySelectorAll('video[data-sidiz-video]').forEach(function (video) {
      if (document.hidden) video.pause();
      else {
        var rect = video.getBoundingClientRect();
        if (isVisible(video) && rect.bottom > 0 && rect.top < window.innerHeight) play(video);
      }
    });
  });
})();
